import React, {useEffect} from 'react';
import Data from '../Data';
import styles from "./Listing.module.scss";
import Article from './Elements/Article';

export default function Listing() {
    useEffect(() => {
        if (window.page) {
            const scrollToElement = document.querySelector(`[data-slug="${window.page}"]`);

            scrollToElement.scrollIntoView({behavior: "smooth", block: 'center'})

            window.page = null;
        }
    }, [])

    return (
        <section className={styles.Main}>
            <div className="container">
                {
                    Data.map((group, index) => {
                        return (
                            <div className={styles.Group} key={index}>
                                {
                                    group.map((box, i) => {
                                        if (Array.isArray(box)) {
                                            return (
                                                <div key={i}>
                                                    {
                                                        box.map(item =>
                                                            <Article {...{item}} key={item.slug}/>
                                                        )
                                                    }
                                                </div>
                                            )
                                        } else {
                                            const item = box;
                                            return <Article {...{item}} big={true} key={item.slug}/>;
                                        }
                                    })
                                }
                            </div>
                        )
                    })
                }
            </div>
        </section>
    )
}